import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import AnimatedBorder from "../components/AnimatedBorder";

function LeftColumn({ className = "" }) {
  const items = ["AX4-39Z", "92L-KQ9", "VXT-203", "BRD-762", "QSN-002", "ZX-0037A", "TRC-9S-1", "00110011", "404.91.76.33", "92.81.00.08"];
  const statusItems = ["Terminal Locked", "Secure Comms Engaged", "Encryption Protocol", "Satlink Online", "Archive // Classified"];
  const [activeStatusIndex, setActiveStatusIndex] = useState(0);
  const [activeItemIndex, setActiveItemIndex] = useState(3);

  useEffect(() => {
    const scheduleNext = () => {
      const randomDelay = Math.random() * 4000 + 1000; // Random between 6s and 10s
      const timeout = setTimeout(() => {
        setActiveStatusIndex(prev => (prev + 1) % statusItems.length);
        scheduleNext();
      }, randomDelay);
      
      return timeout;
    };

    const timeout = scheduleNext();
    return () => clearTimeout(timeout);
  }, [statusItems.length]);

  useEffect(() => {
    const scheduleNextItem = () => {
      const randomDelay = Math.random() * 4000 + 1000; // Random between 6s and 10s
      const timeout = setTimeout(() => {
        setActiveItemIndex(Math.floor(Math.random() * items.length));
        scheduleNextItem();
      }, randomDelay);
      
      return timeout;
    };

    const timeout = scheduleNextItem();
    return () => clearTimeout(timeout);
  }, [items.length]);

  return (
    <aside className={`grid-rows-[1fr_auto] text-left hidden lg:grid pointer-events-none select-none ${className}`}>
      <div className="overflow-auto">
        <AnimatedBorder delay={0.6} duration={1.2} className="space-y py-3">
          {items.map((t, idx) => (
            <motion.div
              key={t}
              initial={{ x: -100, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{
                duration: 0.3,
                delay: 1.8 + idx * 0.05, // Wait for border to finish (0.6s + 1.2s duration)
                ease: "easeOut"
              }}
              className={`px-12 py-1.5 tracking-widest uppercase relative overflow-hidden`}
            >
              <motion.div
                className="absolute inset-0 bg-white right-0"
                initial={{ scaleX: 0 }}
                animate={{ scaleX: idx === activeItemIndex ? 1 : 0 }}
                transition={{ duration: 0.5, ease: "easeInOut" }}
                style={{ transformOrigin: "left" }}
              />
              <motion.span
                className="relative z-10"
                animate={{ color: idx === activeItemIndex ? "#000000" : "#ffffff" }}
                transition={{ duration: 0.25 }}
              >
                {t}
              </motion.span>
            </motion.div>
          ))}
        </AnimatedBorder>
      </div>
      <div className="overflow-hidden -mr-24">
        <AnimatedBorder delay={1.0} duration={1.0} className="py-3 space-y">
          {statusItems.map((t, i) => (
            <motion.div
              key={i}
              initial={{ x: -100, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{
                duration: 0.3,
                delay: 2.0 + i * 0.05, // Wait for border to finish (1.0s + 1.0s duration)
                ease: "easeOut"
              }}
              className={`px-12 py-1.5 tracking-widest uppercase relative overflow-hidden`}
            >
              <motion.div
                className="absolute inset-0 bg-white right-0"
                initial={{ scaleX: 0 }}
                animate={{ scaleX: i === activeStatusIndex ? 1 : 0 }}
                transition={{ duration: 0.5, ease: "easeInOut" }}
                style={{ transformOrigin: "left" }}
              />
              <motion.span
                className="relative z-10"
                animate={{ color: i === activeStatusIndex ? "#000000" : "#ffffff" }}
                transition={{ duration: 0.25 }}
              >
                {t}
              </motion.span>
            </motion.div>
          ))}
        </AnimatedBorder>
      </div>
    </aside>
  );
}

export default LeftColumn;